



export function isBlanck(valor){

    return valor===null || valor === undefined || valor ==='';
}


export function isNotBlanck(valor){

    return !isBlanck(valor);
}


export function padLeft(valor, quant, add){

    let aux = valor===null?"":valor.toString()

    return aux.padStart(quant, add)
}